module.exports = __webpack_public_path__ + "img/dde4bcf.jpg";